import './assets/theme/index.css'
import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import axios from 'axios'
import moment from 'moment'

import App from './App'
import routes from './routes'
import store from './store'
import components from './components/'  // 加载公共组件

Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.prototype.ym_api = '/api/v1';

axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('userhashid');
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$http = axios;

Object.keys(components).forEach((key) => {
    let name = key.replace(/(\w)/, (v) => v.toUpperCase()); // 首字母大写
    Vue.component(`ym${name}`, components[key])
});

export const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

Vue.filter('moment', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
    return moment(value).format(formatString)
});

Vue.filter('date', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD';
    return moment(value).format(formatString)
});

// router.beforeEach((to, from, next) => {
//     let { auth = true } = to.meta;
//     let isLogin = Boolean(window.localStorage.getItem('userhashid'));
//
//     if (auth && !isLogin) {
//         window.location = 'http://auth.int.youmutou.com/api/login/?camefrom=web_dev';
//         return
//     }
//
//     store.commit('addTab', to.name);
//     next()
// });
Vue.prototype.bus = new Vue();

new Vue({
    router,
    store,
    ...App
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js